// components/TransactionHistory.jsx
import React from 'react';

const TransactionHistory = ({ transactions, pagination, onPageChange, loading }) => {
  
  if (loading) {
    return <div className="p-6 text-center text-gray-500">Loading transactions...</div>;
  }

  return (
    <div className="bg-thirdly rounded-xl shadow-sm overflow-hidden">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-100">Transaction History</h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm text-white">
          <thead className="bg-furthly text-white uppercase text-xs font-semibold">
            <tr>
              <th className="px-6 py-4">ID</th>
              <th className="px-6 py-4">Type</th>
              <th className="px-6 py-4">Description</th>
              <th className="px-6 py-4">Date</th>
              <th className="px-6 py-4 text-right">Amount</th>
              <th className="px-6 py-4 text-right">Balance After</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {transactions.length > 0 ? (
              transactions.map((t) => (
                <tr key={t.id} className="text-white transition-colors">
                  <td className="px-6 py-4">#{t.id}</td>
                  <td className="px-6 py-4">
                    <span className="inline-block px-2 py-1 rounded-md text-xs font-medium border border-blue-100">
                      {t.type_text}
                    </span>
                  </td>
                  <td className="px-6 py-4 max-w-xs truncate" title={t.description} dir="auto">
                    {t.description}
                  </td>
                  <td className="px-6 py-4">
                    <div className="font-medium">{t.date}</div>
                    <div className="text-xs">{t.human_date}</div>
                  </td>
                  <td className="px-6 py-4 text-right font-medium">
                    {t.amount}
                  </td>
                  <td className="px-6 py-4 text-right">
                    {t.balance_after}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="px-6 py-10 text-center text-gray-400">
                  No transactions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {pagination && pagination.last_page > 1 && (
        <div className="px-6 py-4 border-t border-gray-700 flex items-center justify-between">
          <span className="text-sm text-gray-500">
            Page {pagination.current_page} of {pagination.last_page}
          </span>
          <div className="flex gap-2">
            <button
              onClick={() => onPageChange(pagination.current_page - 1)}
              disabled={pagination.current_page === 1}
              className="px-3 py-1 text-white bg-secondary text-sm rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>
            <button
              onClick={() => onPageChange(pagination.current_page + 1)}
              disabled={pagination.current_page === pagination.last_page}
              className="px-3 py-1 text-white bg-secondary text-sm rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionHistory;